const items = [
  "Feuerwehr",
  "Rettungsdienst",
  "Katastrophenschutz",
  "Technisches Hilfswerk",
  "Hilfsorganisationen",
  "Verbände",
  "Ausbildungsstätten",
  "Datenschutz in der Praxis",
];

const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    aria-hidden="true"
    className="relative overflow-hidden border-b border-white/5 py-6 select-none"
  >
    <div className="flex w-max animate-marquee">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex shrink-0 items-center">
          {items.map((item) => (
            <span
              key={`${dup}-${item}`}
              className="flex items-center font-mono text-sm uppercase tracking-[0.3em] text-gray-500"
            >
              <span className="px-8">{item}</span>
              <span className="h-1.5 w-1.5 rounded-full bg-blau/60" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default Marquee;
